// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './vue/router'
import store from './vue/store/index'
import './vue/mixins'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './vue/resource/index'
import './vue/components'
import i18n from './vue/i18n/index'
import './vue/filters'
import UUID from 'vue-uuid'
import VueQRCodeComponent from 'vue-qrcode-component'
import VueApexCharts from 'vue-apexcharts'
import VeeValidate from 'vee-validate'
import VueLocalforage from 'v-localforage'
// Main JS (in UMD format)
import VueTimepicker from 'vue2-timepicker'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import CKEditor from '@ckeditor/ckeditor5-vue';
// Maps library
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

import Print from 'vue-print-nb'
import VueCountryCode from "vue-country-code";

// Action Cable
import ActionCableVue from 'actioncable-vue';

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
//pagination
import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
import '../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';

Vue.use(Print);
Vue.use(VueLocalforage, {
  instances: [
    {
      storeName: 'ttjdtbb486b51c9842efdaecd194'
    },
    {
      storeName: 'df5c729d64ed93b36cbbbff41f179'
    },
    {
      storeName: 'cj47054b89dc6c1f821c6e38d'
    },
    {
      storeName:  'a4316afd1e99295017d654'
    }


  ],
})

const VueValidationEs = require('vee-validate/dist/locale/es');
Vue.use(VeeValidate, {
    locale: 'es',
    dictionary: {
      es: VueValidationEs
    }
});

Vue.use( CKEditor );

Vue.config.productionTip = false
Vue.use(VueTimepicker)
Vue.use(DatePicker)
Vue.use(VueCountryCode);
Vue.component('apexchart', VueApexCharts)
Vue.use(Vuetify)
Vue.use(UUID)

// Action Cable Use
Vue.use(ActionCableVue, {
  debug: true, // Configura esto a "false" en producción para deshabilitar mensajes de depuración
  debugLevel: 'all', // Nivel de mensajes de depuración: 'all', 'trace', 'debug', 'info', 'warn', 'error', 'fatal', 'off'
  connectionUrl: 'wss://solutions.fusepong.com/cable', // Reemplaza esto con la URL de tu servidor de Action Cable
  // connectionUrl: 'wss://staging.fusepong.com/cable', // Reemplaza esto con la URL de tu servidor de Action Cable
  // connectionUrl: 'ws://192.168.0.33:4000/cable', // Reemplaza esto con la URL de tu servidor de Action Cable
});

// Moment translate

const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {
  moment
})

.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

// Icons for Leafleft Maps
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  i18n: i18n,
  components: { App },
  template: '<App/>',
  store: store
})


Vue.http.interceptor.before = (request, next) => {

  const skip = request.headers.get('skip');
  if (!skip) {
    const token = localStorage.getItem('user_token');
    const deviceId = localStorage.getItem('device_id');

    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`);
    }
    if (deviceId) {
      request.headers.set('X-Device-ID', deviceId);
    }
  }

  request.headers.delete('skip');

  router.app.updateLoader(true);

  next((response) => {
    router.app.updateLoader(false);

    if (response.status === 401) {
      router.app.$router.push({ name: 'root' });
      router.app.updateIsLogin(false);

      if (response.body.meta && response.body.meta.authentication_token) {
        router.app.checkToken(response.body.meta.authentication_token);
      }

      alert("Tu sesión ha vencido, vuelve a ingresar para continuar");
    }
  });
};



router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.userInfoType.includes(router.app.getUserType()))){
    next();
  }
});



// WEBPACK FOOTER //
// ./src/main.js